// extracted by mini-css-extract-plugin
module.exports = {"Container":"Chat_Container__L0V16","ChatRow":"Chat_ChatRow__1UeFG","Sender":"Chat_Sender__3VHim","Reciver":"Chat_Reciver__1dI24","LightRight":"Chat_LightRight__1W9gQ"};